var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement, SurveyQuestionElementBase, } from "./reactquestion_element";
import { SurveyQuestionCommentValueItem } from "./reactquestion_comment";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
import { ReactElementFactory } from "./element-factory";
import { SurveyPanel } from "./panel";
var SurveyQuestionSelectbase = /** @class */ (function (_super) {
    __extends(SurveyQuestionSelectbase, _super);
    function SurveyQuestionSelectbase(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionSelectbase.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSelectbase.prototype.renderElement = function () {
        var _this = this;
        var cssClasses = this.question.cssClasses;
        return (React.createElement("fieldset", { className: this.question.getSelectBaseRootCss(), ref: function (fieldset) { return (_this.setControl(fieldset)); }, role: this.question.a11y_input_ariaRole, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-describedby": this.question.a11y_input_ariaDescribedBy, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage },
            this.renderHeader(),
            this.question.hasColumns
                ? this.getColumnedBody(cssClasses)
                : this.getBody(cssClasses),
            this.getFooter()));
    };
    SurveyQuestionSelectbase.prototype.renderHeader = function () { return null; };
    SurveyQuestionSelectbase.prototype.getFooter = function () {
        var _this = this;
        if (this.question.hasFootItems) {
            var items = this.question.footItems.map(function (item, ii) {
                return _this.renderItem(item, false, _this.question.cssClasses);
            });
            return React.createElement(React.Fragment, null, items);
        }
        return null;
    };
    SurveyQuestionSelectbase.prototype.getStateValue = function () { return undefined; };
    SurveyQuestionSelectbase.prototype.isItemChecked = function (item, value) { return false; };
    SurveyQuestionSelectbase.prototype.getColumnedBody = function (cssClasses) {
        return (React.createElement("div", { className: cssClasses.rootMultiColumn }, this.getColumns(cssClasses)));
    };
    SurveyQuestionSelectbase.prototype.getColumns = function (cssClasses) {
        var _this = this;
        var value = this.getStateValue();
        return this.question.columns.map(function (column, ci) {
            var items = column.map(function (item, ii) {
                return _this.renderItem(item, ci === 0 && ii === 0, cssClasses, "" + ci + ii, _this.isItemChecked(item, value));
            });
            return (React.createElement("div", { key: "column" + ci + _this.question.getItemsColumnKey(column), className: _this.question.getColumnClass(), role: "presentation" }, items));
        });
    };
    SurveyQuestionSelectbase.prototype.getBody = function (cssClasses) {
        if (this.question.blockedRow) {
            return React.createElement("div", { className: cssClasses.rootRow }, this.getItems(cssClasses, this.question.dataChoices));
        }
        else {
            return React.createElement(React.Fragment, null, this.getItems(cssClasses, this.question.bodyItems));
        }
    };
    SurveyQuestionSelectbase.prototype.getItems = function (cssClasses, choices) {
        var items = [];
        var value = this.getStateValue();
        for (var i = 0; i < choices.length; i++) {
            var item = choices[i];
            var renderedItem = this.renderItem(item, i == 0, cssClasses, "" + i, this.isItemChecked(item, value));
            if (!!renderedItem) {
                items.push(renderedItem);
            }
        }
        return items;
    };
    Object.defineProperty(SurveyQuestionSelectbase.prototype, "textStyle", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSelectbase.prototype.renderItem = function (item, isFirst, cssClasses, index, isChecked) {
        var renderedItem = ReactElementFactory.Instance.createElement(this.question.itemComponent, {
            key: item.uniqueId,
            question: this.question,
            cssClasses: cssClasses,
            isDisplayMode: this.isDisplayMode,
            item: item,
            textStyle: this.textStyle,
            index: index,
            isFirst: isFirst,
            isChecked: isChecked,
            creator: this.props.creator,
        });
        var survey = this.question.survey;
        var wrappedItem = null;
        if (!!survey && !!renderedItem) {
            wrappedItem = ReactSurveyElementsWrapper.wrapItemValue(survey, renderedItem, this.question, item);
        }
        return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
    };
    return SurveyQuestionSelectbase;
}(SurveyQuestionElementBase));
export { SurveyQuestionSelectbase };
var SurveyQuestionSelectBaseItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionSelectBaseItem, _super);
    function SurveyQuestionSelectBaseItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChange = function (event) {
            _this.doOnItemChange(event);
        };
        _this.rootRef = React.createRef();
        return _this;
    }
    SurveyQuestionSelectBaseItem.prototype.getStateElement = function () {
        return this.item;
    };
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "textStyle", {
        get: function () {
            return this.props.textStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "isFirst", {
        get: function () {
            return this.props.isFirst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "index", {
        get: function () {
            return this.props.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "hideCaption", {
        get: function () {
            return this.props.hideCaption === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "ariaLabel", {
        get: function () {
            return this.props.ariaLabel || null;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSelectBaseItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (prevProps.item !== this.props.item && !this.question.isDesignMode) {
            if (this.props.item) {
                this.props.item.setRootElement(this.rootRef.current);
            }
            if (prevProps.item) {
                prevProps.item.setRootElement(undefined);
            }
        }
    };
    SurveyQuestionSelectBaseItem.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState))
            return false;
        return (!this.question.customWidget ||
            !!this.question.customWidgetData.isNeedRender ||
            !!this.question.customWidget.widgetJson.isDefaultRender ||
            !!this.question.customWidget.widgetJson.render);
    };
    SurveyQuestionSelectBaseItem.prototype.doOnItemChange = function (event) { };
    SurveyQuestionSelectBaseItem.prototype.canRender = function () {
        return !!this.item && !!this.question;
    };
    SurveyQuestionSelectBaseItem.prototype.renderElement = function () {
        return React.createElement(React.Fragment, null,
            this.renderElementContent(),
            this.renderPanel(),
            this.renderComment());
    };
    SurveyQuestionSelectBaseItem.prototype.renderElementContent = function () {
        return null;
    };
    Object.defineProperty(SurveyQuestionSelectBaseItem.prototype, "inputStyle", {
        get: function () {
            return null; //{ marginRight: "3px" };
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionSelectBaseItem.prototype.renderComment = function () {
        if (!this.item.isCommentShowing)
            return null;
        return React.createElement("div", { className: this.question.getCommentAreaCss(true) },
            React.createElement(SurveyQuestionCommentValueItem, { question: this.question, item: this.item, cssClasses: this.question.cssClasses }));
    };
    SurveyQuestionSelectBaseItem.prototype.renderPanel = function () {
        if (this.item.isPanelShowing) {
            var panel = this.item.panel;
            return (React.createElement(SurveyPanel, { key: panel.id, element: panel, survey: this.question.survey, cssClasses: this.props.cssClasses, isDisplayMode: this.isDisplayMode, creator: this.props.creator }));
        }
        return null;
    };
    SurveyQuestionSelectBaseItem.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (!this.question.isDesignMode) {
            this.item.setRootElement(this.rootRef.current);
        }
    };
    SurveyQuestionSelectBaseItem.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!this.question.isDesignMode) {
            this.item.setRootElement(undefined);
        }
    };
    return SurveyQuestionSelectBaseItem;
}(ReactSurveyElement));
export { SurveyQuestionSelectBaseItem };
